import {useCallback} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {LockOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {GTMEventApplicationSourceSection} from "../../../application/types/lead/GTMEvenApplicationSourceSection";
import {startRegistrationFlowForCurrentUser} from "../../../auth/actions/start_registration_flow_for_current_user";
import {AuthModalVariant} from "../../../auth/components/auth_modal/AuthModalHeaderVariants";
import {UnlockChoiceEntryPoint} from "../../../auth/types/UnlockChoiceEntryPoint";
import {useFavourites} from "../../../favorite/hooks/use_favourites";
import {useAppDispatch} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {Offer3dView} from "../../constants/offer_3d_views";
import {hasOffer3dView} from "../../utils/has_offer_3d_view";

const PHONE_VERIFICATION_LABEL = "Zweryfikuj numer";

interface Props {
    propertyId?: number;
    offerId?: number;
    photosAvailable?: boolean;
    construction3dTours?: Offer3dView[] | null;
    needsPhoneVerification?: boolean;
}

export const ConstructionGalleryPaywallTrigger = (props: Props) => {
    const {propertyId, offerId, photosAvailable = false, construction3dTours, needsPhoneVerification = false} = props;
    const dispatch = useAppDispatch();
    const {
        addOfferToFavouritesWithoutAuthCheck,
        addPropertyToFavouritesWithoutAuthCheck,
        isOfferInFavourites,
        isPropertyInFavourites,
        favouritePropertiesIds,
        favouriteOfferIds
    } = useFavourites();

    const onRegistrationSuccess = useCallback(async () => {
        if (offerId && propertyId && !photosAvailable && !isPropertyInFavourites(propertyId)) {
            await addPropertyToFavouritesWithoutAuthCheck(propertyId, offerId, false, true);
            return;
        }
        if (offerId && !photosAvailable && !isOfferInFavourites(offerId)) {
            await addOfferToFavouritesWithoutAuthCheck(offerId, true);
        }
    }, [favouriteOfferIds, favouritePropertiesIds]);

    const openAuthModal = (entryCtaLabel: string, showLoginForm?: boolean) => {
        dispatch(
            startRegistrationFlowForCurrentUser({
                userSource: UserSource.REGISTRATION,
                gtmSourceSection: GTMEventApplicationSourceSection.MODAL_CONSTRUCTION_GALLERY,
                titleVariant: AuthModalVariant.CONSTRUCTION_PHOTOS,
                amplitudePlacement: "rp_construction_photos",
                propertyId: propertyId,
                offerId: offerId,
                showLoginForm,
                entryCtaLabel,
                registrationSuccessCallback: onRegistrationSuccess,
                unlockChoiceEntryPoint: UnlockChoiceEntryPoint.CONSTRUCTION_PHOTOS
            })
        );
    };

    const onLogin = () => {
        openAuthModal("Zaloguj się", true);
    };

    const onRegistration = () => {
        openAuthModal("Zarejestruj się");
    };

    const onPhoneVerification = () => {
        openAuthModal(PHONE_VERIFICATION_LABEL);
    };

    const getHeadline = () => {
        if (needsPhoneVerification) {
            return "Zweryfikuj numer telefonu, aby otrzymać dostęp do zdjęć z budowy";
        }

        return hasOffer3dView({id: offerId}, construction3dTours)
            ? "Załóż konto, aby otrzymać dostęp do zdjęć z budowy i widoku 3D"
            : "Wszystkie zdjęcia z budowy dostępne są dla zalogowanych użytkowników";
    };

    return (
        <>
            <div className={overlayStyle} />
            <div className={triggerPlacement}>
                <div className={triggerWrapper}>
                    <div className={cx(holder, textHolder)}>
                        <LockOutlineIcon size="4.4" wrapperSize="4.4" wrapperColor="transparent" fill="white" />
                        <Text variant="headline_5" as="p" align="center">
                            {getHeadline()}
                        </Text>
                    </div>
                    <div className={cx(holder, buttonsHolder)}>
                        {needsPhoneVerification ? (
                            <Button variant="outlined_secondary_light" size="small" fullWidth onClick={onPhoneVerification}>
                                {PHONE_VERIFICATION_LABEL}
                            </Button>
                        ) : (
                            <>
                                <Button variant="outlined_secondary_light" size="small" fullWidth onClick={onRegistration}>
                                    Zarejestruj się
                                </Button>
                                <Button variant="none_secondary" size="small" fullWidth className={loginButtonStyle} onClick={onLogin}>
                                    Zaloguj się
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

const overlayStyle = css({
    width: "100%",
    height: "100%",
    position: "absolute",
    inset: 0,
    zIndex: 1
});

const triggerPlacement = css({
    width: "100%",
    height: "calc(100vh - var(--globals-baseUnit) * 8 - var(--globals-baseUnit) * 12)",
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    position: "absolute",
    inset: 0,
    zIndex: 2,
    py: 5.5,
    overflow: "auto",

    md: {
        alignItems: "center",
        height: "calc(100vh - var(--globals-baseUnit) * 12)"
    }
});

const triggerWrapper = css({
    width: `100%`,
    maxWidth: `744px`,
    color: "var(--colors-white)",
    background: "rgba(35, 35, 45, 0.75)",
    borderRadius: 2,
    pt: 2,
    px: 2,
    pb: 6,
    mx: 1,

    md: {
        py: 8
    }
});

const holder = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1
});

const textHolder = css({
    mb: 3
});

const buttonsHolder = css({
    maxWidth: "200px",
    m: "auto"
});

const loginButtonStyle = css({
    color: "inherit"
});
import {useCallback} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {LockOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {GTMEventApplicationSourceSection} from "../../../application/types/lead/GTMEvenApplicationSourceSection";
import {startRegistrationFlowForCurrentUser} from "../../../auth/actions/start_registration_flow_for_current_user";
import {AuthModalVariant} from "../../../auth/components/auth_modal/AuthModalHeaderVariants";
import {UnlockChoiceEntryPoint} from "../../../auth/types/UnlockChoiceEntryPoint";
import {useFavourites} from "../../../favorite/hooks/use_favourites";
import {useAppDispatch} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {Offer3dView} from "../../constants/offer_3d_views";
import {hasOffer3dView} from "../../utils/has_offer_3d_view";

const PHONE_VERIFICATION_LABEL = "Zweryfikuj numer";

interface Props {
    propertyId?: number;
    offerId?: number;
    photosAvailable?: boolean;
    construction3dTours?: Offer3dView[] | null;
    needsPhoneVerification?: boolean;
}

export const ConstructionGalleryPaywallTrigger = (props: Props) => {
    const {propertyId, offerId, photosAvailable = false, construction3dTours, needsPhoneVerification = false} = props;
    const dispatch = useAppDispatch();
    const {
        addOfferToFavouritesWithoutAuthCheck,
        addPropertyToFavouritesWithoutAuthCheck,
        isOfferInFavourites,
        isPropertyInFavourites,
        favouritePropertiesIds,
        favouriteOfferIds
    } = useFavourites();

    const onRegistrationSuccess = useCallback(async () => {
        if (offerId && propertyId && !photosAvailable && !isPropertyInFavourites(propertyId)) {
            await addPropertyToFavouritesWithoutAuthCheck(propertyId, offerId, false, true);
            return;
        }
        if (offerId && !photosAvailable && !isOfferInFavourites(offerId)) {
            await addOfferToFavouritesWithoutAuthCheck(offerId, true);
        }
    }, [favouriteOfferIds, favouritePropertiesIds]);

    const openAuthModal = (entryCtaLabel: string, showLoginForm?: boolean) => {
        dispatch(
            startRegistrationFlowForCurrentUser({
                userSource: UserSource.REGISTRATION,
                gtmSourceSection: GTMEventApplicationSourceSection.MODAL_CONSTRUCTION_GALLERY,
                titleVariant: AuthModalVariant.CONSTRUCTION_PHOTOS,
                amplitudePlacement: "rp_construction_photos",
                propertyId: propertyId,
                offerId: offerId,
                showLoginForm,
                entryCtaLabel,
                registrationSuccessCallback: onRegistrationSuccess,
                unlockChoiceEntryPoint: UnlockChoiceEntryPoint.CONSTRUCTION_PHOTOS
            })
        );
    };

    const onLogin = () => {
        openAuthModal("Zaloguj się", true);
    };

    const onRegistration = () => {
        openAuthModal("Zarejestruj się");
    };

    const onPhoneVerification = () => {
        openAuthModal(PHONE_VERIFICATION_LABEL);
    };

    const getHeadline = () => {
        if (needsPhoneVerification) {
            return "Zweryfikuj numer telefonu, aby otrzymać dostęp do zdjęć z budowy";
        }

        return hasOffer3dView({id: offerId}, construction3dTours)
            ? "Załóż konto, aby otrzymać dostęp do zdjęć z budowy i widoku 3D"
            : "Wszystkie zdjęcia z budowy dostępne są dla zalogowanych użytkowników";
    };

    return (
        <>
            <div className={overlayStyle} />
            <div className={triggerPlacement}>
                <div className={triggerWrapper}>
                    <div className={cx(holder, textHolder)}>
                        <LockOutlineIcon size="4.4" wrapperSize="4.4" wrapperColor="transparent" fill="white" />
                        <Text variant="headline_5" as="p" align="center">
                            {getHeadline()}
                        </Text>
                    </div>
                    <div className={cx(holder, buttonsHolder)}>
                        {needsPhoneVerification ? (
                            <Button variant="outlined_secondary_light" size="small" fullWidth onClick={onPhoneVerification}>
                                {PHONE_VERIFICATION_LABEL}
                            </Button>
                        ) : (
                            <>
                                <Button variant="outlined_secondary_light" size="small" fullWidth onClick={onRegistration}>
                                    Zarejestruj się
                                </Button>
                                <Button variant="none_secondary" size="small" fullWidth className={loginButtonStyle} onClick={onLogin}>
                                    Zaloguj się
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

const overlayStyle = css({
    width: "100%",
    height: "100%",
    position: "absolute",
    inset: 0,
    zIndex: 1
});

const triggerPlacement = css({
    width: "100%",
    height: "calc(100vh - var(--globals-baseUnit) * 8 - var(--globals-baseUnit) * 12)",
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    position: "absolute",
    inset: 0,
    zIndex: 2,
    py: 5.5,
    overflow: "auto",

    md: {
        alignItems: "center",
        height: "calc(100vh - var(--globals-baseUnit) * 12)"
    }
});

const triggerWrapper = css({
    width: `100%`,
    maxWidth: `744px`,
    color: "var(--colors-white)",
    background: "rgba(35, 35, 45, 0.75)",
    borderRadius: 2,
    pt: 2,
    px: 2,
    pb: 6,
    mx: 1,

    md: {
        py: 8
    }
});

const holder = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1
});

const textHolder = css({
    mb: 3
});

const buttonsHolder = css({
    maxWidth: "200px",
    m: "auto"
});

const loginButtonStyle = css({
    color: "inherit"
});
